
import React from 'react';
import { Tag, Empty } from 'antd';
import { CarOutlined, HomeOutlined, UserOutlined, EnvironmentOutlined } from '@ant-design/icons';
import AppModal from '../../../../layout/popup';
import styles from './styles/ViewMemberVehicles.module.css';

const ViewMemberVehiclesModal = ({ open, onCancel, viewingRecord }) => {
  if (!viewingRecord) {
    return (
      <AppModal
        title="รายละเอียดรถ"
        open={open}
        onCancel={onCancel}
        footer={null}
      >
        <Empty description="ไม่พบข้อมูลสมาชิก" />
      </AppModal>
    );
  }

  const vehicles = viewingRecord.vehicles || [];

  return (
    <AppModal
      icon={<HomeOutlined />}
      title={`บ้านเลขที่ ${viewingRecord.houseNumber}`}
      subtitle={`รายการรถทั้งหมด ${vehicles.length} คัน`}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={640}
      noPadding
    >
      {/* Status tags */}
      <div className={styles.statusBar}>
        <Tag
          icon={<UserOutlined />}
          className={
            viewingRecord.status === 'เจ้าของ' ? styles.tagOwner : styles.tagTenant
          }
        >
          {viewingRecord.status}
        </Tag>
        <span className={styles.vehicleCount}>
          <CarOutlined /> {vehicles.length} คัน
        </span>
      </div>

      {/* Vehicle List */}
      {vehicles.length > 0 ? (
        <div className={styles.vehicleList}>
          {vehicles.map((v, idx) => (
            <div key={v.id || idx} className={styles.vehicleItem}>
              <div className={styles.vehicleIndex}>{idx + 1}</div>
              <div className={styles.vehicleBody}>
                <div className={styles.vehiclePlate}>{v.licensePlate}</div>
                <div className={styles.vehicleInfo}>
                  <span className={styles.vehicleType}>
                    <CarOutlined /> {v.type}
                  </span>
                  <span className={styles.vehicleProvince}>
                    <EnvironmentOutlined /> {v.province}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <Empty description="ไม่มีข้อมูลรถ" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      )}
    </AppModal>
  );
};

export default ViewMemberVehiclesModal;
